var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [(_vm.hasTrainingType)?_c('v-card',{staticClass:"work_calendar_tile d-flex align-content-stretch",attrs:{"flat":"","tile":"","color":_vm.color}},[_c('v-card-text',[_vm._v(_vm._s(_vm.trainingType))])],1):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }